var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInRight", delay: 0, duration: 500 },
          expression: "{ classes: 'slideInRight', delay: 0, duration: 500 }",
        },
      ],
      staticClass: "automation-block-modal",
      attrs: { "block-type": _vm.block.type },
    },
    [
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center align-content-center justify-content-start pb-2",
              },
              [
                _c("BlockIconPreview", {
                  staticClass: "mr-2",
                  staticStyle: { color: "#919ead" },
                  attrs: { "block-type": _vm.block.type },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2." + _vm.block.type))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "name" },
              [
                _c("BlockTitle", {
                  attrs: {
                    name: _vm.block.name,
                    block: _vm.block,
                    "is-save": _vm.isSaveProp,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c(
              "button",
              {
                staticClass: "chatbot-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
            _vm._v(" "),
            !_vm.previewMode
              ? _c(
                  "button",
                  {
                    staticClass: "chatbot-btn",
                    on: {
                      click: function ($event) {
                        return _vm.updatePayload()
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("save")])],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _vm.previewMode
            ? _c(
                "span",
                { staticClass: "bg-primary text-light p-3 w-100 d-block" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.previewModeCaution")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.payload
            ? _c("div", { staticClass: "payload-wrapper" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.addPayload")) +
                    "\n            "
                ),
              ])
            : _c(
                "div",
                { staticClass: "payload-wrapper" },
                [
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.FILTER
                    ? [
                        _c("FilterBlock", {
                          attrs: { automation: _vm.automation },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.WEBHOOK
                    ? [
                        _c("Webhook", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SLEEP
                    ? [
                        _c("Sleep", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION
                    ? [
                        _c("TerminateAutomation", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE
                    ? [
                        _c("SendWhatsappTemplateMessage", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.LOOP
                    ? [
                        _c("Loop", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.FIND_CONTACTS
                    ? [
                        _c("FindContacts", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.STRING_FORMAT
                    ? [
                        _c("StringFormatter", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.NUMBER_FORMAT
                    ? [
                        _c("NumberFormatterChain", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.DATE_FORMAT
                    ? [
                        _c("DateFormatChain", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.RECORDS_FROM_CSV
                    ? [
                        _c("RecordsFromCSV", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.WAIT_FOR
                    ? [
                        _c("WaitFor", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SEND_MAIL
                    ? [
                        _c("SendMail", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.GO_TO_STEP
                    ? [
                        _c("GotoStep", {
                          attrs: {
                            "flatted-diagram": _vm.flattedDiagram,
                            isGotoStep:
                              _vm.block.type ===
                              _vm.AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }